import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import Vue from 'vue'

if (process.env.NODE_ENV === 'production') {
  const dsnElement = document.head.querySelector('meta[name="sentry-dsn"]')
  const releaseElement = document.head.querySelector('meta[name="version"]')
  const environmentElement = document.head.querySelector('meta[name="environment"]')
  const userIdElement = document.head.querySelector('meta[name="user-id"]')

  if (dsnElement && dsnElement.content !== '') {
    Sentry.init({
      dsn: dsnElement.content,
      release: releaseElement ? releaseElement.content : 'Unknown',
      environment: environmentElement ? environmentElement.content : 'Unknown',
      integrations: [
        new VueIntegration({ Vue, attachProps: true }),
        Sentry.thirdPartyErrorFilterIntegration({
          filterKeys: ['ync-sentry-f250c973-9fea-4f20-942f-740cbf7fb1dc'],
          behaviour: 'drop-error-if-contains-third-party-frames',
        }),
      ],
      ignoreErrors: [
        /.\\.children\\[.\\]\\[.\\]=./, // izitoast: undefined is not an object (evaluating 't.children[e][n]=r'),
        'Non-Error promise rejection captured',
        // Ignore the network errors
        'Network Error',
        'NetworkError',
        'AbortError',
      ],
    })

    if (userIdElement) {
      Sentry.setUser({ id: userIdElement.content })
    }
  }
}
